module.exports = __webpack_public_path__ + "static/media/img-fechar-icon.abcb33e7.svg";